import React from "react";
import styles from "./styles.module.scss";
import { ArrowIcon } from "../Icons";

interface HeroV2Props {
  signupLink: string;
}

const HeroV2: React.FC<HeroV2Props> = ({ signupLink }) => {
  return (
    <header
      id="topo"
      className={styles.hero}
      style={{ backgroundImage: "url(/images-capa2/hero/noise-bg.svg)" }}
    >
      <div className={styles.inner}>
        <div className={styles.content}>
          <h1>
            Parceiros Promo: monetize com um dos maiores programas de afiliados
            do país!
          </h1>
          <p>
            <strong>Divulgue nossas marcas</strong> no seu blog, site, redes
            sociais, WhatsApp… e <strong>garanta comissão</strong> por toda
            venda feita em seu link!
          </p>
          <a href={signupLink} className={styles.button} title="Quero ser um Parceiro">
            <span>Quero ser um Parceiro!</span>
            <ArrowIcon />
          </a>
        </div>

        <div className={styles.media}>
          <img
            className={styles.curveLine}
            src="/images-capa2/hero/curve-line.svg"
            alt=""
            aria-hidden="true"
          />
          <svg
            className={styles.blob}
            width="837"
            height="563"
            viewBox="-104.5 -118 837 563"
            preserveAspectRatio="xMaxYMax meet"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <defs>
              <clipPath id="heroBlobClip">
                <path d="M427.09 9.03613C501.952 -4.62075 547.291 -1.11379 621.9 14.0342C677.076 25.2365 751.842 59.3419 779.721 72.627C786.378 75.7995 790.5 82.5144 790.5 89.9004V452.044H3.23828C4.25378 451.716 5.5075 451.307 6.97949 450.814C11.3676 449.345 17.7015 447.144 25.4893 444.218C41.0643 438.365 62.457 429.61 85.7266 417.995C132.247 394.775 186.347 360.09 216.418 314.274C228.959 295.167 234.624 273.379 237.34 250.521C240.054 227.676 239.826 203.704 240.551 180.263C242.002 133.325 247.276 88.4557 287.303 57.9414C336.376 20.5306 370.066 19.4389 427.09 9.03613Z" />
              </clipPath>
            </defs>
            <g clipPath="url(#heroBlobClip)">
              <image
                href="/images-capa2/_misc/paris-at-sunset.png"
                x="-104.5"
                y="-118"
                width="837"
                height="563"
                preserveAspectRatio="xMidYMid slice"
              />
              <rect
                x="-104.5"
                y="-118"
                width="837"
                height="563"
                fill="#8776DE"
                fillOpacity="0.45"
              />
            </g>
            <path
              d="M427.09 9.03613C501.952 -4.62075 547.291 -1.11379 621.9 14.0342C677.076 25.2365 751.842 59.3419 779.721 72.627C786.378 75.7995 790.5 82.5144 790.5 89.9004V452.044H3.23828C4.25378 451.716 5.5075 451.307 6.97949 450.814C11.3676 449.345 17.7015 447.144 25.4893 444.218C41.0643 438.365 62.457 429.61 85.7266 417.995C132.247 394.775 186.347 360.09 216.418 314.274C228.959 295.167 234.624 273.379 237.34 250.521C240.054 227.676 239.826 203.704 240.551 180.263C242.002 133.325 247.276 88.4557 287.303 57.9414C336.376 20.5306 370.066 19.4389 427.09 9.03613Z"
              fill="none"
              stroke="#CAC1F7"
            />
          </svg>
          <img
            className={styles.influencer}
            src="/images-capa2/hero/influencer.png"
            alt="Influenciadora criando conteúdo"
            title="Parceiros Promo"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.visibility = "hidden";
            }}
          />
        </div>
      </div>

      <img
        className={`${styles.sparkle} ${styles.sparkleTopLeft}`}
        src="/images-capa2/hero/sparkle.svg"
        alt=""
        aria-hidden="true"
      />
      <img
        className={`${styles.sparkle} ${styles.sparkleCenter}`}
        src="/images-capa2/hero/sparkle.svg"
        alt=""
        aria-hidden="true"
      />
      <img
        className={`${styles.sparkle} ${styles.sparkleTopRight}`}
        src="/images-capa2/hero/sparkle.svg"
        alt=""
        aria-hidden="true"
      />
    </header>
  );
};

export default HeroV2;
